function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/admin/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const adminRoutes = [
  {
    path: '/admin/dashboard',
    component: view('Dashboard'),
    name: 'admin.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/wifi-vouchers',
    component: view('WifiVouchers'),
    name: 'admin.wifi-vouchers',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Wifi Vouchers',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/purposes',
    component: view('Purposes'),
    name: 'admin.purposes',
    meta: {
      breadcrumb: [
        {
          text: 'Maintenances'
        },
        {
          text: 'Purposes',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/organizations',
    component: view('Organizations'),
    name: 'admin.organizations',
    meta: {
      breadcrumb: [
        {
          text: 'Maintenances'
        },
        {
          text: 'Organizations',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/durations',
    component: view('Durations'),
    name: 'admin.durations',
    meta: {
      breadcrumb: [
        {
          text: 'Maintenances'
        },
        {
          text: 'Durations',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/user-accounts',
    component: view('UserAccounts'),
    name: 'admin.user-accounts',
    meta: {
      breadcrumb: [
        {
          text: 'Maintenances'
        },
        {
          text: 'User Accounts',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/vouchers',
    component: view('Vouchers'),
    name: 'admin.vouchers',
    meta: {
      breadcrumb: [
        {
          text: 'Maintenances'
        },
        {
          text: 'Vouchers',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/reports/voucher-by-organizations',
    component: view('VoucherByOrganizations'),
    name: 'admin.reports.voucher-by-organizations',
    meta: {
      breadcrumb: [
        {
          text: 'Reports'
        },
        {
          text: 'Voucher By Organizations',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/reports/voucher-by-purposes',
    component: view('VoucherByPurposes'),
    name: 'admin.reports.voucher-by-purposes',
    meta: {
      breadcrumb: [
        {
          text: 'Reports'
        },
        {
          text: 'Voucher By Purposes',
          active: true
        }
      ]
    }
  }
]

export default adminRoutes
